  <form [formGroup]="myTaskForm">  
  <div class="createTask"> 
    <div class="block colorExternal">
      <div class="selectTaskColor">
        <div class="selectedColor" (click)="toggleColorSelection()">
          <span [ngStyle]="{ 'background-color': selectedColor }"></span>
          <mat-icon>arrow_drop_down</mat-icon>
        </div>
        <div class="colGroup" *ngIf="showColorPannel">
          <ng-container *ngFor="let color of colors; let i; as: index">
            <label class="colm" [ngStyle]="{ 'background-color': color.colname }">
              <input  type="radio" id="{{ i }}" type="radio" value="{{ color.colname }}"
               (click)="SelectColor(color.colname)" name="noteColor"/>
              <span class="checkmark"></span>
            </label>
          </ng-container>
        </div>
      </div>
      <div class="extrnalTask">
        <!-- <mat-checkbox color="primary" formControlName="isInternal">External Task</mat-checkbox> -->
        <mat-checkbox color="primary" formControlName="isInternal">External Task</mat-checkbox>
        <mat-checkbox class="ml-5" color="primary" formControlName="isDueDateTrigger">Due Date Trigger</mat-checkbox>
      </div>
    </div>
    <div class="block">
      <mat-form-field class="taskTitle">
        <mat-label>Title</mat-label>
        <input matInput formControlName="title" maxlength="100" placeholder="Task Name"/>
      </mat-form-field>
    </div>

    <div class="block block_division">
      <mat-form-field class="dateInput">
        <mat-label>Start date</mat-label>
          <input matInput [matDatepicker]="picker1" formControlName="startDate" readonly>
          <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>      
      </mat-form-field>
      
      <mat-form-field class="dateInput">      
        <mat-label>Due date</mat-label>
          <input matInput [matDatepicker]="picker" formControlName="dueDate" readonly>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>      
       
      </mat-form-field>
    </div>
    <div class="block">
      <mat-form-field>
        <mat-label>Description</mat-label>
        <textarea matInput formControlName="description" maxlength="500"
          cdkTextareaAutosize
          cdkAutosizeMinRows="1"
          cdkAutosizeMaxRows="2">
        </textarea>
      </mat-form-field>
    </div>

          <!-- Attach  3C-->
          
             <div class="reminder">
              <div class="remind">
                <div class="mlabel">Attach To</div>      
                <mat-slide-toggle color="primary" [checked]="isAttachEntity" (change)="getAttached3c($event)">
                </mat-slide-toggle> 
              </div>
  
              <ng-container *ngIf="isAttachEntity">           
                <div class="block mt-10">
                  <mat-radio-group aria-label="Select an option" color="primary" (change)="selectCCC($event)">
                    <mat-radio-button value="Core" [checked]="checkedAttachCore">{{CoreShowName}}</mat-radio-button>&nbsp;
                    <mat-radio-button value="Contact" [checked]="checkedAttachContact">{{ContactShowName}}</mat-radio-button>&nbsp;
                    <mat-radio-button value="Company" [checked]="checkedAttachCompany">{{CompanyShowName}}</mat-radio-button>
                  </mat-radio-group>
                </div>
  
  
                <div class="block mt-10" *ngIf="ShowAttchedToCore">
                  <mat-form-field appearance="outline" class="mt-10 mb-10" style="position: relative;">
                    <mat-label>Search {{CoreShowName}}</mat-label>
                    <input matInput maxlength="50" placeholder="Type & Select" aria-label="State" [matAutocomplete]="auto"
                      (input)="searchCore($event.target.value)" [formControl]="stateCtrl" id="stateCtrlid">
                    <mat-autocomplete #auto="matAutocomplete">
                      <mat-option (click)="attchedToCoreSelected(core)" *ngFor="let core of attachedToCoreList"
                        [value]="core.name">
                        <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
                          <div class="userpic">
                            <img *ngIf="core.imageUrl!='' " src="{{core.imageUrl}}" alt="">
                            <span class="username" *ngIf="core.imageUrl==''" class="username">
                              {{core.shortName}}
                            </span>
                          </div>
                          <div class="info">
                            <p> {{ core.name }}</p>
                            <p class="email">{{ core.email }}</p>
                          </div>
                        </span>
                      </mat-option>
                    </mat-autocomplete>
  
                  </mat-form-field>
                  <ul class="selectedlist" *ngFor="let core of attachedToSelectedCore">
                    <li *ngIf="!core.isDeleted">
                      <div class="userndetail">
                        <div class="userpic">
                          <img *ngIf="core.img!=''" src="{{core.img}}" alt="">
                          <span *ngIf="core.img==''" class="username">
                            {{core.shortName}}
                          </span>
                        </div>
                        <div class="details">
                          <h4>{{core.name}}</h4>
                          <p>{{core.email}}</p>
                        </div>
                        <div class="opt">
                          <button mat-icon-button>
                            <mat-icon (click)="attchedToRemoveCore(core)">cancel</mat-icon>
                          </button>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
  
                <div class="block mt-10" *ngIf="ShowAttchedToContact">
                  <mat-form-field appearance="outline" class="mt-10 mb-10" style="position: relative;">
                    <mat-label>Search {{ContactShowName}}</mat-label>
                    <input matInput maxlength="50" placeholder="Type & Select" aria-label="State" [matAutocomplete]="auto"
                      (input)="searchContacts($event.target.value)" [formControl]="stateCtrl" id="stateCtrlid">
                    <mat-autocomplete #auto="matAutocomplete">
                      <mat-option (click)="attchedToContactSelected(contact)"
                        *ngFor="let contact of attachedToContactList" [value]="contact.name">
                        <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
                          <div class="userpic">
                            <img *ngIf="contact.imageUrl!=''" src="{{contact.imageUrl}}" alt="">
                            <span class="username" *ngIf="contact.imageUrl==''" class="username">
                              {{contact.shortName}}
                            </span>
                          </div>
                          <div class="info">
                            <p> {{ contact.name }}</p>
                            <p class="email">{{ contact.email }}</p>
                          </div>
                        </span>
                      </mat-option>
                    </mat-autocomplete>
  
                  </mat-form-field>
                  <ul class="selectedlist" *ngFor="let contact of attachedToSelectedContact">
                    <li *ngIf="!contact.isDeleted">
                      <div class="userndetail">
                        <div class="userpic">
                          <img *ngIf="contact.img!=''" src="{{contact.img}}" alt="">
                          <span *ngIf="contact.img==''" class="username">
                            {{contact.shortName}}
                          </span>
                        </div>
                        <div class="details">
                          <h4>{{contact.name}}</h4>
                          <p>{{contact.email}}</p>
                        </div>
                        <div class="opt">
                          <button mat-icon-button>
                            <mat-icon (click)="attchedToRemoveContact(contact)">cancel</mat-icon>
                          </button>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
  
                <div class="block mt-10" *ngIf="ShowAttchedToCompany">
                  <mat-form-field appearance="outline" class="mt-10 mb-10" style="position: relative;">
                    <mat-label>Search {{CompanyShowName}}</mat-label>
                    <input matInput maxlength="50" placeholder="Type & Select" aria-label="State" [matAutocomplete]="auto"
                      (input)="searchCompany($event.target.value)" [formControl]="stateCtrl" id="stateCtrlid">
                    <mat-autocomplete #auto="matAutocomplete">
                      <mat-option (click)="attchedToCompanySelected(company)"
                        *ngFor="let company of attachedToCompanyList" [value]="company.name">
                        <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
                          <div class="userpic">
                            <img *ngIf="company.imageUrl!=''" src="{{company.imageUrl}}" alt="">
                            <span class="username" *ngIf="company.imageUrl==''" class="username">
                              {{company.shortName}}
                            </span>
                          </div>
                          <div class="info">
                            <p> {{ company.name }}</p>
                            <p class="email">{{ company.email }}</p>
                          </div>
                        </span>
                      </mat-option>
                    </mat-autocomplete>
  
                  </mat-form-field>
                  <ul class="selectedlist" *ngFor="let company of attachedToSelectedCompany">
                    <li *ngIf="!company.isDeleted">
                      <div class="userndetail">
                        <div class="userpic">
                          <img *ngIf="company.img!=''" src="{{company.img}}" alt="">
                          <span *ngIf="company.img==''" class="username">
                            {{company.shortName}}
                          </span>
                        </div>
                        <div class="details">
                          <h4>{{company.name}}</h4>
                          <p>{{company.email}}</p>
                        </div>
                        <div class="opt">
                          <button mat-icon-button>
                            <mat-icon (click)="attchedToRemoveCompany(company)">cancel</mat-icon>
                          </button>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
               
              </ng-container>
  
            </div>

             <ng-container>
              <div class="reminder">
                <div class="remind">
                  <div class="mlabel">Assigned To</div>
                  <mat-slide-toggle color="primary" [checked]="isAssignedEntity" (change)="getAssigned3c($event)">
                  </mat-slide-toggle> 
                </div>
                <ng-container *ngIf="isAssignedEntity">
                <div class="block mt-10">

                  <mat-radio-group aria-label="Select an option" color="primary" (change)="selectCRE($event)">
                    <mat-radio-button  value="Role">Role</mat-radio-button> &nbsp;                 
                      <mat-radio-button value="User">User</mat-radio-button>&nbsp;
                      <mat-radio-button value="Contact">{{ ContactShowName}}</mat-radio-button>&nbsp;
                      <mat-radio-button value="Email">Email</mat-radio-button>
                  </mat-radio-group>
                 
                </div>
    
                <div class="block mt-10" *ngIf="ShowContactBox">
                  <mat-form-field appearance="outline"  class="mt-10 mb-10" style="position: relative;">
                    <mat-label>Search {{ ContactShowName}}</mat-label>
                    <input matInput maxlength="50" placeholder="Type & Select" aria-label="State" [matAutocomplete]="auto"
                      (input)="searchContacts($event.target.value)" [formControl]="stateCtrl" id="stateCtrlid"
                      (keydown.enter)="onEnter($event,'')">
                    <mat-autocomplete #auto="matAutocomplete">
                      <mat-option (keydown.enter)="onEnter($event,contact)" (click)="contactSelected(contact)"
                        *ngFor="let contact of attachedToContactList" [value]="contact.name">
                        <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
                          <div class="userpic">
                            <img *ngIf="contact.imageUrl!=''" src="{{contact.imageUrl}}" alt="">
                            <span class="username" *ngIf="contact.imageUrl==''" class="username">
                              {{contact.shortName}}
                            </span>
                          </div>
                          <div class="info">
                            <p> {{ contact.name }}</p>
                            <p class="email">{{ contact.email }}</p>
                          </div>
                        </span>
                      </mat-option>
                    </mat-autocomplete>
    
                  </mat-form-field>

                 
                </div>
    
                <div class="block mt-10" *ngIf="ShowRoleBox">
                  <mat-form-field appearance="outline"  class="mt-10 mb-10" style="position: relative;">
                    <mat-label>Search role</mat-label>
                    <input matInput maxlength="50" placeholder="Search role" aria-label="State" [matAutocomplete]="auto"
                      (input)="searchRoles($event.target.value)" [formControl]="stateCtrl" id="stateCtrlid">
                    <mat-autocomplete #auto="matAutocomplete">
                      <mat-option (click)="roleSelected(obj)" *ngFor="let obj of RoleList" [value]="obj.roleName">
                        <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
                          <div class="info">
                            <p> {{ obj.roleName }}</p>
                          </div>
                        </span>
                      </mat-option>
                    </mat-autocomplete>
    
                  </mat-form-field>

                
                </div>    
    
                <div class="block mt-10" *ngIf="ShowEmailBox">
                  <div class="relative">
                    <mat-form-field appearance="outline" >
                      <input matInput maxlength="100" class="form-control mtb-15" placeholder="Add email"
                        [(value)]="emailAssigned" (input)="emailCheck($event.target.value)" />
                    </mat-form-field>
      
                    <button color="primary" *ngIf="addEmailButtonShow" (click)="addEmail()" mat-icon-button>
                      <mat-icon>add</mat-icon>
                    </button>
                  </div>    
                
    
                </div>    
    
                <div class="block mt-10" *ngIf="ShowUserBox">
                  <mat-form-field appearance="outline"  class="mt-10 mb-10" style="position: relative;">
                    <mat-label>Search user</mat-label>
                    <input matInput maxlength="50" placeholder="Type & Select" aria-label="State" [matAutocomplete]="auto"
                      (input)="searchUser($event.target.value)" [formControl]="stateCtrl" id="stateCtrlid">
                    <mat-autocomplete #auto="matAutocomplete">
                      <mat-option (click)="userSelected(user)" *ngFor="let user of userList" [value]="user.name">
                        <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
                          <div class="userpic">
                            <img *ngIf="user.imageUrl!=''" src="{{user.imageUrl}}" alt="">
                            <span class="username" *ngIf="user.imageUrl==''" class="username">
                              {{user.shortName}}
                            </span>
                          </div>
                          <div class="info">
                            <p> {{ user.name }}</p>
                            <p class="email">{{ user.email }}</p>
                          </div>
                        </span>
                      </mat-option>
                    </mat-autocomplete>
    
                  </mat-form-field>

                 
                </div>

                <div class="block mt-10" *ngIf="ShowRelationshipBox">
                  <mat-form-field appearance="outline"  class="mt-10 mb-10" style="position: relative;">
                    <mat-label>Search Relationship</mat-label>
                    <input matInput maxlength="50" placeholder="Type & Select" aria-label="State" [matAutocomplete]="auto"
                      (input)="searchRelationShip($event.target.value)" [formControl]="stateCtrl" id="stateCtrlid">
                    <mat-autocomplete #auto="matAutocomplete">
                      <mat-option (click)="relationSelected(rls)" *ngFor="let rls of resultUIRelationship" [value]="rls.name">
                        <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
                          <div class="userpic">
                            <img *ngIf="rls.imageUrl!=''" src="{{rls.imageUrl}}" alt="">                       
                          </div>
                          <div class="info">
                            <p><span class="role">{{ rls.rloeName }}</span> {{ rls.name }}</p>
                            <p class="email">{{ rls.email }}</p>
                          </div>
                        </span>
                      </mat-option>
                    </mat-autocomplete>
    
                  </mat-form-field>
                
                </div>

                <ul class="selectedlist">
                  <li *ngFor="let ass of selectedAssignedTo">
                    <div class="userndetail">
                      <div class="userpic">
                        <img *ngIf="ass.img!=''" src="{{ass.img}}" alt="">
                        <span *ngIf="ass.img==''" class="username">
                          {{ass.shortName}}
                        </span>
                      </div>
                      <div class="details">
                        <h4>{{ass.name}}</h4>
                        <p>{{ass.email}}</p>
                      </div>
                      <div class="opt">
                        <button mat-icon-button>
                          <mat-icon (click)="removeAssignedTo(ass)">cancel</mat-icon>
                        </button>
                      </div>
                    </div>
                  </li>
                </ul>

              </ng-container>
              </div>
            </ng-container>

    <div class="actionBtnHolder">
      <button mat-flat-button class="cancel" (click)="close()">
        Close
      </button>
      <button mat-flat-button class="calltoaction" type="submit" color="primary"
      [disabled]="myTaskForm.invalid || !myTaskForm.dirty" type="submit"
      (click)="SaveTaskDetails(myTaskForm.value)">
        Add
        <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
        </mat-spinner></mat-icon>
      </button>
    </div>
  </div> 
</form>













